module.exports = __webpack_public_path__ + "static/media/ic_send.c1951f58.svg";